export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
     resource: 'AccessBothUser',
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      guest: true,
    },
  },
  {
    path: '/verify',
    name: 'verify-otp',
    component: () => import('@/views/login/verifyOtp.vue'),
    meta: {
      layout: 'full',
      resource: 'AccessBothUser',
      auth: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/register/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'AccessBothUser',
      guest: true,
    },
  },
{
    path: '/details',
    name: 'details-page',
    component: () => import('@/views/register/Userdetails.vue'),
    meta: {
      layout: 'full',
      resource: 'AccessBothUser',
      auth: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },

  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },

  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
]
